import * as React from "react";
import * as PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";

const top = 50;
const left = 50;

const classes = (theme => ({

    paper: {
        position: 'absolute',
        width: 650,
        backgroundColor: 'white',
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        textAlign: 'center',
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    },
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

class PhotoModal extends React.Component {

    constructor(props) {
        super(props);
        console.log(this.props.file);
        this.state = {
            file: this.props.file,
            zoomedInFileName: this.props.file.name
        };
    }

    componentDidMount() {
        let canvas = this.imageZoomedInCanvas;
        let ctx = canvas.getContext('2d');
        let reader = new FileReader();
        reader.onload = function(e) {
            let img = new Image();
            img.onload = function() {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                canvas.width = (img.width/(img.height/650));
                canvas.height = 650;
                ctx.drawImage(img,0,0, (img.width/(img.height/650)), 650);
            };
            img.src = e.target.result;
        };
        reader.readAsDataURL(this.state.file);
    }

    render() {
        const { zoomedInFileName } = this.state;
        const { classes } = this.props;

        return (
            <div className={classes.paper}>
                <Typography component="h2" variant="h5">
                    {zoomedInFileName}
                </Typography>
                <canvas id="imageZoomedInCanvas" ref={(ref) => {
                    this.imageZoomedInCanvas = ref
                }}/>
            </div>
        );
    }
}

PhotoModal.propTypes = {
    file: PropTypes.object.isRequired,
};

export default withStyles(classes)(PhotoModal);